import { configureStore } from "@reduxjs/toolkit";
import PurchaseOrdersPaginationReducer from "../pages/Inventory/PurchaseOrders/slices/PaginationSlice";
import ReceivedInventoryPaginationReducer from "../pages/Inventory/InventoryReceived/slices/PaginationSlice";
import SalesPaginationReducer from "../pages/Inventory/Sales/slices/PaginationSlice";
import BranchesPaginationReducer from "../pages/Configuration/Branches/slices/PaginationSlice";
import ItemsPaginationReducer from "../pages/Configuration/Items/slices/PaginationSlice";
import ItemCategoriesPaginationReducer from "../pages/Configuration/ItemCategories/slices/PaginationSlice";
import SuppliersPaginationReducer from "../pages/Configuration/Suppliers/slices/PaginationSlice";
import CustomersPaginationReducer from "../pages/Configuration/Customers/slices/PaginationSlice";
import StaffPaginationReducer from "../pages/Configuration/Staff/slices/PaginationSlice";
import PaymentAccountsPaginationReducer from "../pages/Configuration/PaymentAccounts/slices/PaginationSlice";
import creditManagementPaginationReducer from "../pages/Inventory/CreditManagement/slices/PaginationSlice";
import unpaidInvoicesReportPaginationReducer from "../pages/Reports/CreditManagement/UnpaidInvoicesReport/slices/PaginationSlice";
import creditManagementPaymentTrendsReportPaginationReducer from "../pages/Reports/CreditManagement/PaymentTrendsReport/slices/PaginationSlice";
import creditManagementReportPaginationReducer from "../pages/Reports/CreditManagement/CreditActivityReport/slices/PaginationSlice";
import creditManagementVisualizationPaginationReducer from "../pages/Reports/CreditManagement/Visualization/slices/PaginationSlice";
import DashboardPaginationReducer from "../pages/Dashboard/slices/DashboardPaginationSlice";
import expensesCategoriesPaginationReducer from "../pages/Configuration/ExpensesCategories/slices/PaginationSlice";
import expensesManagementPaginationReducer from "../pages/Inventory/ExpensesManagement/slices/PaginationSlice";
import expensesRegisterReportPaginationReducer from "../pages/Reports/ExpensesReports/ExpensesRegisterReport/slices/PaginationSlice";
import expensesCategorySummaryReportPaginationReducer from "../pages/Reports/ExpensesReports/CategorySummaryReport/slices/PaginationSlice";
import expensesVisualizationPaginationReducer from "../pages/Reports/ExpensesReports/Visualization/slices/PaginationSlice";
import expensesCategoryCashAccountReportPaginationReducer from "../pages/Reports/ExpensesReports/CashAccountSummaryReport/slices/PaginationSlice";

export const store = configureStore({
  reducer: {
    DashboardPagination: DashboardPaginationReducer,
    purchaseOrdersPagination: PurchaseOrdersPaginationReducer,
    receivedInventoryPagination: ReceivedInventoryPaginationReducer,
    salesPagination: SalesPaginationReducer,
    branchesPagination: BranchesPaginationReducer,
    itemsPagination: ItemsPaginationReducer,
    itemCategoriesPagination: ItemCategoriesPaginationReducer,
    suppliersPagination: SuppliersPaginationReducer,
    customersPagination: CustomersPaginationReducer,
    staffPagination: StaffPaginationReducer,
    paymentAccountsPagination: PaymentAccountsPaginationReducer,
    creditManagementPagination: creditManagementPaginationReducer,
    unpaidInvoicesReportPagination: unpaidInvoicesReportPaginationReducer,
    creditManagementPaymentTrendsReportPagination:
      creditManagementPaymentTrendsReportPaginationReducer,
    creditManagementReportPagination: creditManagementReportPaginationReducer,
    creditManagementVisualizationPagination:
      creditManagementVisualizationPaginationReducer,
    expensesCategoriesPagination: expensesCategoriesPaginationReducer,
    expensesManagementPagination: expensesManagementPaginationReducer,
    expensesRegisterReportPagination: expensesRegisterReportPaginationReducer,
    expensesCategorySummaryReportPagination:
      expensesCategorySummaryReportPaginationReducer,
    expensesVisualizationPagination: expensesVisualizationPaginationReducer,
    expensesCategoryCashAccountReportPagination:
      expensesCategoryCashAccountReportPaginationReducer,
  },
});
